module.exports = __webpack_public_path__ + "img/1726044628838-kedai patmis.jpg.dcb5edd1.webp";